// material-ui

import drilldowntripicon from '../../../assets/images/drill-down-trip.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const DrillDownTripIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={drilldowntripicon} alt="Drill Down Trip" width="22"  />
    );
};

export default DrillDownTripIcon;


